import React from 'react'
import { Term } from 'services/ContentfulService/models/term'
import { GlossaryTerm } from './GlossaryTerm'
import { View } from 'reshaped/bundle'

interface Props {
	terms: Term[]
}

export const GlossaryList = ({ terms }: React.PropsWithChildren<Props>) => {
	return (
		<View maxWidth="970px" direction="row" wrap attributes={{ style: { justifyContent: 'space-between' } }} gap={4}>
			{terms.map(term => (
				<GlossaryTerm key={term.id} term={term} />
			))}
		</View>
	)
}
